<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
      <!-- Brand Name -->
      <router-link :to="{name: 'home'}" class="navbar-brand">HOT WHEELS FRONT END</router-link>
      <!-- Toggler Button -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- Navbar Content -->
      <div class="collapse navbar-collapse" id="navbarsExampleDefault">
        <!-- Navbar Items -->
        <div class="navbar-nav ms-auto">
          <!-- Authentication Links -->
          <template v-if="!loggedIn">
          </template>
          <template v-else>
            <!-- Profile Dropdown -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" d-flex align-items-center href="#" id="profileDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                {{ userName }} || ${{ userBalance }}
                <img src="/images/blankimage.jpg" alt="Profile" class="rounded-circle me-2" style="width: 30px; height: 30px;" />
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
                <li>
                  <router-link :to="{ name: 'profile' }" class="dropdown-item">
                    {{ $t('myProfile') }}
                  </router-link>
                </li>
                <!-- <li>
                  <a class="dropdown-item" href="#" @click.prevent="logout">{{ $t('logout') }}</a>
                </li> -->
              </ul>
            </li>
          </template>
        </div>
      </div>
      <!-- Language Dropdown (Always Visible) -->
      <!-- <div class="dropdown d-none d-md-block ms-3">
        <a
          class="nav-link dropdown-toggle text-light"
          href="#"
          id="languageDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ $t('language') }}
        </a>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
          <li><a class="dropdown-item" href="#" @click.prevent="setLanguage('en')">English</a></li>
          <li><a class="dropdown-item" href="#" @click.prevent="setLanguage('cn')">中文 (简体)</a></li>
        </ul>
      </div> -->
    </nav>
    <router-view></router-view>
  </div>
</template>


<script>
  import axios from "axios";
  // import i18n from './lang/index';
  const SPRINGBOOTAPIURL = process.env.VUE_APP_SPRINGBOOTAPIURL;
  const BETAPIURL = process.env.VUE_APP_SPRINGBOOTBETAPIURL;

  export default {
    name: 'App',
    data() {
      return {
        token: this.getQueryParam('token'), // Token state
        loading: false,  // Loading state
        error: null,     // Error state
        userName: '',    // User name
        userBalance: 0,  // User balance
        loggedIn: false, // Login state
      };
    },
    methods: {
      getQueryParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
      },
      async authenticateToken() {
        if (!this.token) {
          console.error('No token found in URL');
          return; // Prevent the request if token is not available
        }
        
        // Start loading process
        this.loading = true;
        try {
          const response = await axios.post(
            `${SPRINGBOOTAPIURL}/authentication`,
            { token: this.token },
            {
              headers: {
                'Content-Type': 'application/json',
              },
              withCredentials: true,  // Send credentials with the request
            }
          );
          console.log('Response:', response.data);
          
          if (response.data.data) {
            console.log('Logged in successful.');
            // // Store user data in local storage
            // localStorage.setItem('user', JSON.stringify(response.data.data));

            // Assign username and balance to the component's data
            this.userName = response.data.data.username;
            this.userBalance = response.data.data.balance;

            console.log(this.userName);
            console.log(this.userBalance);

            // Update login state
            this.loggedIn = true;
          } else {
            console.log('Error');
            this.error = 'Authentication failed: ' + response.data.message;
          }
        } catch (error) {
          this.error = 'Error occurred while authenticating: ' + error.message;
          console.error('Error:', error);
        } finally {
          this.loading = false;  // Stop loading once the request is completed (success or failure)
        }
      },
      async fetchBalance() {
        if (!this.userName) return;
        try {
          const response = await axios.get(
            `${BETAPIURL}/api/get-balance`,
            {
              params: { userName: this.userName },
              withCredentials: true
            }
          );

          if (response.data.success) {
            this.userBalance = response.data.data.balance;
            console.log("Balance updated:", this.userBalance);
          } else {
            console.warn("Balance fetch failed:", response.data.message);
          }
        } catch (error) {
          console.error('Failed to fetch balance:', error);
        }
      }
    },
    mounted() {
      // Store token in localStorage if present in the query parameter
      const token = this.getQueryParam('token');
      if (token) {
        localStorage.setItem('token', token);
        this.token = token;
      } else {
        this.token = localStorage.getItem('token');
      }

      // Authenticate token
      if (this.token) {
        this.authenticateToken();
        // Start polling balance every 10 seconds
        this.balanceInterval = setInterval(() => {
          this.fetchBalance();
        }, 5000); // 5000ms = 5s, 10000ms = 10s
      } else {
        console.error('No token available! User is not logged in!');
      }
    },
    beforeUnmount() {
      console.log("Balance state cleared!");
      if (this.balanceInterval) {
        clearInterval(this.balanceInterval);
      }
    }
  };
</script>

<style>
/* Scoped styles */
/* #app {
  font-family: 'Roboto', sans-serif;
} */
/* Light theme (default) */
/* .light-theme {
  background-color: white;
  color: black;
} */

/* Dark theme */
/* .dark-theme {
  background-color: black;
  color: white;
} */

/* Navbar text adjustment */
/* .navbar-dark .navbar-brand {
  color: inherit;
} */
</style>